import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { DeviceScreen } from 'screens/device';

export default withPermissions(DeviceScreen, [GroupSecurity.DeviceRead]);
